import API from './client'
import type { INotification } from '../types/notification'

interface GetNotificationsResponse {
  notifications: INotification[]
  unreadCount: number
}

export const notificationsAPI = {
  getAll: async (params?: { limit?: number; unreadOnly?: boolean }): Promise<GetNotificationsResponse> => {
    const res = await API.get('/notifications', { params })
    return res.data
  },

  markRead: async (id: string): Promise<void> => {
    await API.patch(`/notifications/${id}/read`)
  },

  markAllRead: async (): Promise<void> => {
    await API.patch('/notifications/read-all')
  },
}
